import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import App from './App.tsx';
import './index.css';

import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v6';

// Datadog ENV Vars
const DD_SERVICE = import.meta.env.VITE_DD_SERVICE;
const DD_ENV = import.meta.env.VITE_DD_ENV;

// Initialize Datadog
datadogRum.init({
    applicationId: 'c062fdd7-b5f4-4c1c-87e8-a97464da3bdc',
    clientToken: 'pubd84001ddba60683d3871a4ba202a8c41',
    site: 'datadoghq.com',
    service: DD_SERVICE,
    env: DD_ENV,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'allow',
    plugins: [reactPlugin({ router: true })],
});

// Set up routing — App handles all routing internally via <Routes>
const router = createBrowserRouter([
  {
    path: '*', // All routes handled inside App
    element: <App />
  }
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
